import React from "react";
import { Link } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import loopholeLogo from "../../assets/logos/horizontalLogoWhite.svg";
import styles from "./footer.module.css";

// Replace "#" with the real Loophole social URLs when available.
const socialLinks = [
  { label: "Facebook", href: "#", Icon: FacebookIcon },
  { label: "Instagram", href: "#", Icon: InstagramIcon },
  { label: "LinkedIn", href: "#", Icon: LinkedInIcon },
  { label: "X", href: "#", Icon: XIcon },
];

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <img src={loopholeLogo} alt="loophole logo" className={styles.logo} />
          <p className={styles.tagline}>
            Zambia's modern marketplace for renting and buying property — built
            for tenants and landlords alike.
          </p>
          <div className={styles.socials}>
            {socialLinks.map(({ label, href, Icon }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                className={styles.socialLink}
                target="_blank"
                rel="noreferrer"
              >
                <Icon fontSize="small" />
              </a>
            ))}
          </div>
        </div>

        <nav className={styles.links}>
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Explore</h4>
            <Link to="/salesListings" className={styles.link}>
              Buy
            </Link>
            <Link to="/rentalListings" className={styles.link}>
              Rent
            </Link>
            <Link to="/contactUs" className={styles.link}>
              Consult
            </Link>
            <Link to="/roadmap" className={styles.link}>
              Roadmap
            </Link>
            <Link to="/about" className={styles.link}>
              About Us
            </Link>
          </div>
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Account</h4>
            <Link to="/manager/dashboard" className={styles.link}>
              Dashboard
            </Link>
            <Link to="/properties" className={styles.link}>
              Properties
            </Link>
            <Link to="/auth" className={styles.link}>
              Sign in
            </Link>
          </div>
        </nav>
      </div>
      <div className={styles.bottom}>
        <span>© {new Date().getFullYear()} Loophole. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
